import { inject, Injectable } from '@angular/core';
import io, { Socket } from 'socket.io-client';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Message } from '../model/message/message';
import { MessageFactory } from '../model/message/message-factory';
import { AuthorizationService } from '../auth/authorization.service';
import { RestService } from '../engine/http/rest.service';
import { ObjectFactory } from '../engine/http/factory/object-factory';

@Injectable({
  providedIn: 'root',
})
export class MessageSocketService {
  private auth = inject(AuthorizationService);
  private rest = inject(RestService);

  private socket: Socket;
  private isSocketConnected = false;
  private messages$: BehaviorSubject<Message[]> = new BehaviorSubject<
    Message[]
  >([]);
  public messages: Message[] = [];
  public factory = new MessageFactory();

  public connect(api: string): Observable<any> {
    return this.rest.get(new ObjectFactory(api));
  }

  public subscribe(listener: {
    next: (data: Message[]) => void;
    err?: (error) => void;
  }): Subscription {
    if (!this.auth.isAuthenticated) {
      throw new Error('No user authenticated');
    }
    if (!this.isSocketConnected) {
      this.connectToSocket();
    }
    return this.messages$.subscribe(listener);
  }

  protected createSocket(): Socket {
    return io();
  }

  private connectToSocket() {
    this.socket = this.createSocket();
    this.isSocketConnected = true;
    const user = this.auth.user.name;

    this.socket.on('new Message', (data) => {
      this.messages.splice(0, 0, this.factory.build(data));
      this.messages$.next(this.messages.slice());
    });

    this.socket.on('messages', (data) => {
      this.messages = data.map((d: any) => this.factory.build(d));
      this.messages$.next(this.messages.slice());
    });

    this.socket.emit('getAll', user);
  }

  flagMessage(message: Message) {
    if (!this.socket) {
      throw new Error('Socket not connected');
    }
    this.socket.emit('read', {
      message: message.id,
      user: this.auth.user.name,
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.isSocketConnected = false;
      this.socket = null;
    }
  }
}
